import { Trans } from "@lingui/react/macro";
import React from "react";
import * as styles from "./ImmersivePictureCard.module.scss";
import { LinkPictureCardProps } from "../LinkPictureCard";
import { WrapWithLink, actionFromCardAction } from "components/WrapWithLink";
import {
  Button,
  ImageRatio,
  isSanityImagePresent,
  ResponsiveSanityImage
} from "@silversea-ssc/ui-components-react";
import { CardAction } from "../cardAction";
import { isPresent } from "src/utils/checks";

type Props = {
  image?: LinkPictureCardProps["image"];
  altText?: string;
  action: CardAction | undefined;
  trackingName: string;
  title: string | undefined;
};

const ImmersivePictureCard: React.FC<Props> = ({
  altText,
  image,
  action,
  trackingName,
  title
}) => {
  const withAction =
    isPresent(action) && (isPresent(action.href) || isPresent(action.onClick));

  return (
    <WrapWithLink
      {...actionFromCardAction(action)}
      data-content-piece={trackingName}
    >
      <div className={styles.wrapper}>
        <ImageRatio ratio="auto" width={360} height={360}>
          {isSanityImagePresent(image) && (
            <ResponsiveSanityImage
              image={image}
              defaultWidth={360}
              defaultHeight={360}
              draggable={false}
              loading="lazy"
              alt={altText}
            />
          )}
        </ImageRatio>

        <div className={styles.content}>
          <h4 className={styles.title}>{title}</h4>
          {withAction && (
            <Button
              renderAs="div"
              variant="primary"
              inverted
              size="small"
              className={styles.button}
              iconName="arrow-right"
              dataContentPiece="more_button"
            >
              {action.linkLabel || (
                <Trans id="cta-discover-more">Discover more</Trans>
              )}
            </Button>
          )}
        </div>
      </div>
    </WrapWithLink>
  );
};

export default ImmersivePictureCard;
